import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { AccountTypeOptionsDTO } from '../../../api/useAutomatedAccountsQuery';
import { VisualPickerButton } from '../../../../../CommonComponents/OPL/VisualPickerButton/VisualPickerButton';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { WorkflowCurrentStepFC } from '../../../AutoAccountWorkflow.types';
import { StepCard } from '../../StepCard/StepCard';
import { IraAccountType } from '../../../../../ApexOPL/AccountOpening/AccountOpening.meta';

export const ACCOUNT_TYPE = 'accountType';

export interface AccountTypeFormField {
  [ACCOUNT_TYPE]?: AccountTypeOptionsDTO | null;
}

export const TypeOfRetirementAccount: WorkflowCurrentStepFC = ({ data, onNext }) => {
  const { setValue } = useFormContext<AccountTypeFormField>();

  return (
    <StepCard>
      <Text color="neutral.700" fontSize="h3" fontWeight={500}>
        What type of retirement account is right for you?
      </Text>

      <Box display="flex" flexDirection="column">
        {data.allowedIraAccountTypes.includes(IraAccountType.TraditionalIra) && (
          <VisualPickerButton
            mt="32"
            helperText="Contributions are tax-deductible, earnings grow tax-free, and withdrawals are subject to income tax."
            onClick={() => {
              setValue(ACCOUNT_TYPE, AccountTypeOptionsDTO.TraditionalIRA);
              onNext();
            }}
          >
            Traditional IRA
          </VisualPickerButton>
        )}

        {data.allowedIraAccountTypes.includes(IraAccountType.RothIra) && (
          <VisualPickerButton
            mt="16"
            helperText="Contributions are taxed, and then earnings and withdrawals are tax-free. Qualifying conditions apply."
            onClick={() => {
              setValue(ACCOUNT_TYPE, AccountTypeOptionsDTO.RothIRA);
              onNext();
            }}
          >
            Roth IRA
          </VisualPickerButton>
        )}

        {data.allowedIraAccountTypes.includes(IraAccountType.RolloverIra) && (
          <VisualPickerButton
            mt="16"
            helperText="Move a previous retirement account."
            onClick={() => {
              setValue(ACCOUNT_TYPE, AccountTypeOptionsDTO.RollOver401k);
              onNext();
            }}
          >
            Roll over a 401(k) to an IRA
          </VisualPickerButton>
        )}

        {data.allowedIraAccountTypes.includes(IraAccountType.SimpleIraParticipant) && (
          <VisualPickerButton
            mt="16"
            helperText="Pre-tax contribution. Reduces your taxable income, providing a tax benefit today."
            onClick={() => {
              setValue(ACCOUNT_TYPE, AccountTypeOptionsDTO.SimpleIRA);
              onNext();
            }}
          >
            Simple IRA
          </VisualPickerButton>
        )}
      </Box>
    </StepCard>
  );
};
